import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { AwardingMethodCode } from '@/queries/program_purses/schemas.ts'

type UpdateParams = { purse_id: number; program_id: number }
type UpdatePayload = {
  can_distribute_funds_automatically?: boolean
  status?: 0 | 1
  source_type?: number
  sub_source_type?: number
  name?: string
  awarding_method_code?: AwardingMethodCode
}

async function updatePurseRequest(
  params: UpdateParams,
  payload: UpdatePayload
) {
  await axios.put(
    `/programs/${params.program_id}/purses/${params.purse_id}`,
    payload
  )
  return null
}

type UpdateRequest = {
  params: UpdateParams
  payload: UpdatePayload
}

export const useUpdateProgramPurse = () => {
  return useMutation({
    mutationFn: async ({ params, payload }: UpdateRequest) =>
      updatePurseRequest(params, payload),
  })
}
